import React from 'react';
import { useAppSelector } from 'flow/hooks/useRedux';
import { ActiveCallKey, TicketKey } from 'flow/types/EntityKeys';

import { ActiveCallDirections } from 'flow/utils/call-utils';
import { selectOwnUserHasCapabilityTickets } from 'flow/selectors/TicketsSelectors';
import { selectOwnActiveLineDirection } from 'flow/selectors/call-selectors';
import { selectOwnCustomerKey } from 'flow/selectors/customer-selectors';
import WidgetGoToTicket from './omni-ticket-widget/WidgetGoToTicket';
import WidgetCreateTicket from './omni-ticket-widget/WidgetCreateTicket';

interface Props {
    ticketKey?: TicketKey;
    className?: string;
    activeCallKey?: ActiveCallKey;
}

const OmniTicketWidget = ({ ticketKey, className, activeCallKey }: Props) => {
    const hasCapabilityTickets = useAppSelector(
        selectOwnUserHasCapabilityTickets,
    );
    const ownCustomerIsHelixTest = useAppSelector(selectOwnCustomerIsHelixTest);
    const callDirection = useAppSelector((state) =>
        selectOwnActiveLineDirection(state, activeCallKey),
    );

    if (ticketKey && callDirection === ActiveCallDirections.INCOMING.value)
        return <WidgetGoToTicket ticketKey={ticketKey} className={className} />;

    if (!ownCustomerIsHelixTest || !hasCapabilityTickets) return null;

    return (
        <WidgetCreateTicket
            activeCallKey={activeCallKey}
            className={className}
        />
    );
};

export default React.memo(OmniTicketWidget);

const selectOwnCustomerIsHelixTest = (state) =>
    selectOwnCustomerKey(state) === 'customer-210056';
